import { CalendarEvent } from 'mini-calendar-event-types';
import { getCalendarForCalendarEvent } from './getCalendarForCalendarEvent';

/**
 * Checks if the event is a part of any of the owner's calendars
 * @param event
 */
export const isEventInPeoplesCalendar = (event: CalendarEvent): boolean =>
    !!getCalendarForCalendarEvent(event)?.isPeopleCalendar;
